import { startNextCallRef } from "../services/callSessionRefs";

export function useGlobalCallRefs() {
  return { startNextCallRef };
}
